import { render, staticRenderFns } from "./nav-user-center.vue?vue&type=template&id=a178073c&scoped=true"
import script from "./nav-user-center.vue?vue&type=script&lang=js"
export * from "./nav-user-center.vue?vue&type=script&lang=js"
import style0 from "./nav-user-center.vue?vue&type=style&index=0&id=a178073c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a178073c",
  null
  
)

export default component.exports